import { WarehousesCatalog } from "../views/WarehousesCatalog/WarehousesPage";
import { ContractsConditionsCatalog } from "../views/contractsConditionsCatalog/ContractsConditionsCatalog";
import SgcConfigurations from "../views/SgcConfigurations/SgcConfigurations";
import { GasMovements } from "../views/GasMovements/GasMovementsPage";
import { Products } from "../views/Products/ProductsPage";
import { ConditionsView } from "../views/Conditions/ConditionsView";
import { PrintersView } from "../views/printers/PrintersView";
import { TaxisView } from "../views/taxis/TaxisView";
import { ShipperTrucksPage } from "../views/ShipperTrucks/ShipperTrucksPage";
import NfcTagsView from "../views/nfcTags/NfcTagsView";
import { LibraryBooks } from "@material-ui/icons";
import { AdminUnitsView } from "views/adminUnits/AdminUnitsView";
import { PERMISSIONS } from "router/permissions";
import { adminUnitsTypes } from "redux/reducers/adminUnits/types";
import ElectronicEquipmentView from "views/ElectronicEquipment/ElectronicEquipmentView";
import electronicEquipmentActionTypes from "redux/reducers/electronicEquipment/types";
import AccountingAccountView from "views/AccountingAccount/AccountingAccountView";
import ACCOUNTING_ACCOUNT_TYPES from "redux/reducers/accountingAccount/accountingAccountTypes";
import AccountingAccountRelationView from "views/AccountingAccountRelation/AccountingAccountRelationView";
import ACCOUNTING_ACCOUNT_RELATION_TYPES from "redux/reducers/accountingAccountRelation/accountingAccountRelationTypes";

const {
  CATALOGS,
  CATALOGS_NFC_TAG,
  UNITS_CATALOG,
  CATALOGS_PRODUCTS,
  CATALOGS_CONTRACTS,
  CATALOGS_CONDITIONS_COMER,
  CATALOGS_FLOTILLA,
  SGC_CONFIG,
  PRINTERS,
  ELECTRONIC_EQUIPMENT_CATALOG,
  CATALOGS_PG,
  CATALOGS_STORAGE,
  CATALOGS_CONCEPT_BONIFICATION,
  CATALOGS_ACCOUNTING_ACCOUNTS,
  CATALOGS_RELATIONSHIP_ACCOUNTING_ACCOUNTS,
} = PERMISSIONS;

const adminUnitsErrorConf = {
  reducer: "adminUnits",
  restoreKey: adminUnitsTypes.RESTORE_INITIAL_STATE,
};

const electronicEquipmentErrorConf = {
  reducer: "electronicEquipment",
  retoreKey: electronicEquipmentActionTypes.RESTORE_INITIAL_STATE
};

const accountingAccountErrorConf = {
  reducer: "accountingAccount",
  restoreKey: ACCOUNTING_ACCOUNT_TYPES.RESTORE_INITIAL_STATE
};

const accountingAccountRelationErrorConf = {
  reducer: "accountingAccountRelation",
  restoreKey: ACCOUNTING_ACCOUNT_RELATION_TYPES.RESTORE_INITIAL_STATE,
};

export const catalogsRoutes = [
  {
    collapse: true,
    name: "Catálogos",
    icon: LibraryBooks,
    state: "catalogsCollapse",
    inSidebar: true,
    isProtected: true,
    rule: CATALOGS,
    views: [
      {
        path: "/almacenes",
        name: "Almacenes",
        mini: "AL",
        component: WarehousesCatalog,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: CATALOGS_STORAGE,
        noTitle: true,
      },
      {
        path: "/condicion-contratos",
        name: "Condiciones",
        mini: "CD",
        component: ContractsConditionsCatalog,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: CATALOGS_CONTRACTS,
        noTitle: true,
      },
      {
        path: "/configuraciones-sgc",
        name: "Configuraciones SGC",
        mini: "CS",
        component: SgcConfigurations,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: SGC_CONFIG,
        noTitle: true,
      },
      {
        path: "/movimientosGas",
        name: "Bonificación de Gas",
        mini: "MG",
        component: GasMovements,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: CATALOGS_CONCEPT_BONIFICATION,
        noTitle: true,
      },
      {
        path: "/productos",
        name: "Productos",
        mini: "PR",
        component: Products,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: CATALOGS_PRODUCTS,
        noTitle: true,
      },
      {
        path: "/condiciones",
        name: "Condiciones de Comercio",
        mini: "CC",
        component: ConditionsView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: CATALOGS_CONDITIONS_COMER,
        noTitle: true,
      },
      {
        path: "/taxis",
        name: "Flotillas",
        mini: "FL",
        component: TaxisView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: CATALOGS_FLOTILLA,
        noTitle: true,
      },
      {
        path: "/impresoras",
        name: "Impresoras",
        mini: "IMP",
        component: PrintersView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: PRINTERS,
      },
      {
        path: "/ShipperTrucks",
        name: "PG",
        mini: "PG",
        component: ShipperTrucksPage,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: CATALOGS_PG,
      },
      {
        path: "/sgc-tags",
        name: "NFC Tag",
        mini: "NFC",
        component: NfcTagsView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: CATALOGS_NFC_TAG,
      },
      {
        path: "/unidades-administrativas",
        name: "Administración de Unidades",
        mini: "UA",
        component: AdminUnitsView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: UNITS_CATALOG,
        ...adminUnitsErrorConf,
      },
      {
        path: "/equipo-electronico",
        name: "Equipo Electrónico",
        mini: "EE",
        component: ElectronicEquipmentView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: ELECTRONIC_EQUIPMENT_CATALOG,
        noTitle: true,
        ...electronicEquipmentErrorConf,
      },
      {
        path: "/accounting-accounts",
        name: "Cuenta Contable",
        mini: "CCo",
        component: AccountingAccountView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: CATALOGS_ACCOUNTING_ACCOUNTS,
        noTitle: false,
        ...accountingAccountErrorConf,
      },
      {
        path: "/accounting-accounts-relation",
        name: "Relación Cuenta Contable",
        mini: "RCC",
        component: AccountingAccountRelationView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: CATALOGS_RELATIONSHIP_ACCOUNTING_ACCOUNTS,
        noTitle: false,
        ...accountingAccountRelationErrorConf,
      },
    ],
  },
];
